import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsOpen, sidebarActions } from 'redux/app/sidebar/sidebar.slice';

export const useMainLayoutComponent = () => {
  const dispatch = useDispatch();
  const sidebarOpen = useSelector(selectIsOpen);
  const onCloseSidebar = useCallback(
    () => dispatch(sidebarActions.setOpen(false)),
    [dispatch],
  );

  return { sidebarOpen, onCloseSidebar };
};
